import Star from './star';

export default Star;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/cards/review/components/stars/components/index.ts